<nz-table nzBordered nzSize="middle" [nzData]="tickets" [nzShowPagination]="false">

	<thead>
		<tr>
			<th>Workflow</th>
			<th>Product</th>
			<th>Policy Number</th>
			<th></th>
		</tr>
	</thead>

	<tbody *ngIf="tickets">
		<tr *ngFor="let t of tickets" class="clickable-row">
			<td>{{ t.workflowLabel }}</td>
			<td>{{ t.policy?.product?.name }}</td>
			<td>{{ t.policy?.policyNumber }}</td>
			<td>
				<button nz-button nzType="primary" nzSize="small" (click)="open(t)">
					Open
				</button>
			</td>
		</tr>
	</tbody>
</nz-table>
